module.exports = __webpack_public_path__ + "static/media/wgl2.png.c588208b.jpg";